/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {TrackSuccessfulTransferInRequest} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'
import {TrackSuccessfulTransferInResponse} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'


export const trackSuccessfulTransferIn = (request: TrackSuccessfulTransferInRequest, options?: CashRequestOptions) => post<TrackSuccessfulTransferInRequest, TrackSuccessfulTransferInResponse>("/2.0/cash/track-successful-transfer-in", request, {...options, rejectOnError: true })